import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IAppState } from 'src/app/core/store/common/interfaces/app-state.interface';
import * as EnrollmentActions from 'src/app/core/store/onboarding/actions/enrollment.actions';

@Component({
  selector: 'app-client-additional-info-request-dashboard',
  templateUrl: './client-additional-info-request-dashboard.component.html',
  styleUrls: ['./client-additional-info-request-dashboard.component.scss'],
})
export class ClientAdditionalInfoRequestDashboardComponent implements OnInit {
  subscriptions: Subscription[] = [];

  constructor(private route: ActivatedRoute, private store: Store<IAppState>) {}
  ngOnInit(): void {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        this.store.dispatch(
          EnrollmentActions.DashboardStateIdAction({
            dashboardStateId: params['stateId'],
          })
        );
      })
    );
  }
}
